import classNames from 'classnames';
import React from 'react';
import { GA_VIEW_MORE_ACTION } from '../../constants/analytics';
import { FeatureFlags } from '../../types/index';
import { SearchEventCard } from '../EventCard';
import { SeeMoreButton } from '../SeeMoreButton';

const getCards = ({
    cards,
    isMobile,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    affCode,
    renderPromotedResults,
}: {
    cards: any;
    isMobile: boolean;
    isAuthenticated: boolean;
    onTrackClick: Function;
    onTrackClickInternal?: Function;
    trackGAEvent?: Function;
    experiments: any;
    featureFlags: FeatureFlags;
    affCode?: string;
    renderPromotedResults: boolean;
}) => {
    const classes = classNames({
        'eds-g-cell eds-g-cell-3-12 eds-g-cell--has-overflow': !isMobile,
        'small-card-mobile': isMobile,
    });

    return cards.map(({ id, ...cardProps }: { id: string }, index: number) => {
        return (
            <div className={classes} key={id}>
                <SearchEventCard
                    id={id}
                    isAuthenticated={isAuthenticated}
                    trackGAEvent={trackGAEvent}
                    trackClick={onTrackClick.bind(null, { id })}
                    trackClickInternal={onTrackClickInternal?.bind(null, index)}
                    experiments={experiments}
                    featureFlags={featureFlags}
                    affCode={affCode}
                    renderPromoted={renderPromotedResults}
                    {...cardProps}
                />
            </div>
        );
    });
};

export const SmallEventCardGroup = ({
    cards,
    linkUrl,
    isAuthenticated,
    onTrackClick,
    title,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    affCode,
    enableClientSideLinking,
    renderPromotedResults,
}: {
    cards: any;
    linkUrl: string;
    isAuthenticated: boolean;
    onTrackClick: Function;
    title: string;
    onTrackClickInternal?: Function;
    trackGAEvent?: Function;
    experiments: any;
    featureFlags: FeatureFlags;
    affCode?: string;
    enableClientSideLinking?: boolean;
    renderPromotedResults: boolean;
}) => (
    <div className="browse-cards-container">
        <div className="eds-show-up-md">
            {getCards({
                cards,
                isMobile: false,
                isAuthenticated,
                onTrackClick,
                onTrackClickInternal,
                trackGAEvent,
                experiments,
                featureFlags,
                affCode,
                renderPromotedResults,
            })}
        </div>
        <div className="eds-show-down-mn">
            <div className="mobile-card-carousel eds-l-mar-bot-4">
                {getCards({
                    cards,
                    isMobile: true,
                    isAuthenticated,
                    onTrackClick,
                    onTrackClickInternal,
                    trackGAEvent,
                    experiments,
                    featureFlags,
                    affCode,
                    renderPromotedResults,
                })}
            </div>
            <div className="eds-show-down-sn eds-align--center">
                <div className="eds-g-cell">
                    <SeeMoreButton
                        linkUrl={linkUrl}
                        trackClick={onTrackClick}
                        title={title}
                        gaAction={GA_VIEW_MORE_ACTION}
                        enableClientSideLinking={enableClientSideLinking}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default SmallEventCardGroup;
